import { Box, Button, Grid, Hidden, Typography } from "@mui/material"
import { useStyles } from "./styles"
import CustomAccordion from "../../../../../../components/accordion"
import { useState } from "react"
import { QuestionProps } from "./types"
import { Answer } from "../answer"
import { AnswerHeader } from "../answerHeader"
import { QuestionOptionType } from "../../../../../../utils/enums/optionType"
import { Actions } from "../actions"
import { ActionDrawer } from "../../../../../../components/ActionDrawer"
import EvidenceDetail from "../../../../../actionPlans/pages/form/components/evidenceDetail"
import { useEvidences } from "../../../../../../hooks/evidences/useEvidences"
import { QuestionActions } from "../questionActions"
import { useTranslation } from "react-i18next"
import { SnackSimple } from "../../../../../../components"
import { useEvidenceDownload } from "../../hooks"

const Question = ({ answers, position, title, type, textHelp, description, evidenceQuestion, evidenceMultiple }: QuestionProps) => {
    const styles = useStyles()
    const [expand, setExpand] = useState(true)
    const { t } = useTranslation()
    const { evidences, existEvidences, } = useEvidences({ evidencesResponse: evidenceQuestion || [] })
    const evidenceAnswerMultiple = useEvidences({ evidencesResponse: evidenceMultiple || [] })

    // Función para alternar el estado de expansión
    const toggleExpand = () => {
        setExpand(!expand)
    }

    const { disable, openSnackbar, handleCloseSnackbar, downloadEvidences } = useEvidenceDownload(`evidencias de ${title}`,evidenceQuestion);

    return (
        <ActionDrawer
            title="EVIDENCIAS"
            body={
                <Box sx={styles.mainContainer}>
                    <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                            image: evidences?.images,
                            comment: evidences?.comments,
                            documents: evidences?.documents,
                            video: evidences?.video,
                        }}
                    />
                <Box>
                    <Button variant='text_primary' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                </Box>
            </Box>
            }
        >
            {({ openDrawer }) => (<>
                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
                <CustomAccordion
                    accordionProps={{
                        sx: styles.background
                    }}
                    title={(
                        <Box sx={styles.container}>
                            <Box sx={styles.counter}><p>{position}</p></Box>

                            <Box sx={styles.header}>
                                <Box sx={styles.questions}>
                                    <Typography variant="subtitle" fontWeight='700' sx={styles.headerTitle}>{title}</Typography>

                                    {!!description && <Typography variant="caption">{description}</Typography>}
                                </Box>

                                <QuestionActions active={!evidenceQuestion?.length} expand={expand} openDrawer={openDrawer} toggleExpand={toggleExpand} downloadEvidences={downloadEvidences} disable={disable} />
                            </Box>


                            {!!textHelp && <Typography variant="subtitle">{t('general.textHelp', {textHelp})}</Typography>}
                        </Box>
                    )}
                    expandIcon={null}
                    /* onChange={() => { setExpand(!expand) }} */
                    expanded={expand}
                    description={(
                        <Box sx={styles.answers}>
                            <AnswerHeader isCatalog={answers[0].isCatalog} />

                            <Box sx={[styles.answers, styles.maxScroll]}>
                                {answers?.map(answer => (<Answer type={type} {...answer} />))}
                            </Box>

                        </Box>
                    )}
                />
            </>)}
        </ActionDrawer>
    )
}

export { Question }
